module.exports = __webpack_public_path__ + "static/media/20ECE19.baaca7e4.jpg";